<template>
  <div class="part">
    <p class="input-filter-label">{{ noteHeadline }}</p>
    <div class="textarea-wrapper">
      <textarea
        rows="4"
        maxlength="255"
        class="textarea"
        :placeholder="noteType"
        :value="textareaValue"
        @input="textareaInput">
      </textarea>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      noteHeadline: {
        type: String,
        required: true
      },
      noteType: {
        type: String,
        required: true
      },
      textareaValue: {
        type: [String, Object]
      }
    },
    methods: {
      textareaInput (e) {
        this.$emit('textareaInput', e.target.value)
      }
    }
  }
</script>
